import axiosInstance from "../services/axiosInstance";

export const UserCompanies = async () => {
  try {
    const response = await axiosInstance.post("console/user/companies");

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const ChangeWorkspaceApi = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/workspace/change",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const handleUpdateSchedule = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/workspace/user/schedule",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const HandleRegisterOrganization = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/organizations/register",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchLeaveApprovers = async (company_id, search) => {
  try {
    const response = await axiosInstance.get(
      "console/leave/approvers?company_id=" + company_id + "&search=" + search,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchCompanyCoordinates = async (
  company_id,
  search = null,
  defaultValue = null,
) => {
  try {
    const response = await axiosInstance.get(
      "console/workspace/coordinates/get?company_id=" +
        company_id +
        "&search=" +
        search +
        "&default=" +
        defaultValue,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchAttendanceLists = async ({
  companyId,
  page = 1,
  perPage = 10,
  search = "",
  dateFrom = "",
  dateTo = "",
}) => {
  try {
    const response = await axiosInstance.get(`console/attendance/lists`, {
      params: {
        company_id: companyId,
        page,
        perPage,
        search,
        date_from: dateFrom,
        date_to: dateTo,
      },
    });

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};
